module.exports = __webpack_public_path__ + "img/footer_wave2.5511b115.png";